import React from 'react';
import MessageCard from './MessageCard';
import QuickQuestionButton from './QuickQuestionButton';
import { Message } from '../types';

interface MessageListProps {
  messages: Message[];
  isLoading: boolean;
  hasConversation: boolean;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  onQuickQuestionClick?: (question: string) => void;
  onRetry?: (index: number) => void;
  onEdit?: (index: number) => void;
  onFeedback?: (messageId: string, feedback: 'like' | 'dislike' | null) => void;
}

const MessageList: React.FC<MessageListProps> = ({
  messages,
  isLoading,
  hasConversation,
  scrollContainerRef,
  onQuickQuestionClick,
  onRetry,
  onEdit,
  onFeedback,
}) => {
  // Default quick questions
  const quickQuestions = [
    "What is the primary aim of the Sir Rupert Myers Sustainability Award?",
    "Which university facilitated the establishment of the International Universities Climate Alliance?",
    "What action is suggested to support both SDG 5 (Gender Equality) and SDG 13 (Climate Action)?",
    "How can a person support SDG 10 (Reduced Inequalities) online, based on the United Nations' guide?",
  ];

  if (!hasConversation) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center max-w-2xl px-4">
          <p className="text-gray-400 mb-8">
            Welcome! I'm the SDG AI Assistant, here to chat about all things SDGs. What's on your mind?
          </p>

          {/* Quick Question Buttons Area */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {quickQuestions.map((question, index) => (
              <QuickQuestionButton
                key={index}
                question={question}
                onQuestionClick={onQuickQuestionClick || (() => {})}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div ref={scrollContainerRef} className="flex-1 overflow-y-auto px-4 py-8">
      <div className="max-w-3xl mx-auto space-y-6">
        {messages.map((message, index) => {
          const canEdit = !message.isBot && Boolean(message.messageId);
          return (
            <div
              key={index}
              className={`flex ${message.isBot ? 'justify-start' : 'justify-end'}`}
            >
              <MessageCard
                isBot={message.isBot}
                content={message.content}
                stopped={message.stopped}
                error={message.error}
                references={message.references}
                reask={message.reask}
                messageId={message.messageId}
                userFeedback={message.userFeedback}
                onRetry={message.isBot && onRetry ? () => onRetry(index) : undefined}
                onEdit={canEdit && onEdit ? () => onEdit(index) : undefined}
                onQuickQuestionClick={onQuickQuestionClick}
                onFeedback={message.isBot && message.messageId ? onFeedback : undefined}
              />
            </div>
          );
        })}
        {isLoading && (
          <div className="flex justify-start">
            <MessageCard isBot loading />
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageList;